import React from 'react';
import { STATSCORE_WIDGET_LIVESCORE, WidgetContext, bgWidgetEnabled, brWidgetS5Enabled, getBetgeniustWidgetUrl, getFlashbetWidgetUrl, statsCoreWidgetEnabled } from '../../../data/widgets/WidgetContext';
import BetGeniusWidget from '../../widgets/BetGeniusWidget';
import FlashbetWidget from '../../widgets/FlashbetWidget';
import StatsCoreWidget from '../../widgets/StatsCoreWidget';

export default function LiveTracker(props) {
    const widgetContext = React.useContext(WidgetContext);

    const event = props.event;
    const isBrWidgetS5 = brWidgetS5Enabled(event.sportRef,event.widgetType);
    const isBetgeniusWidget = bgWidgetEnabled(event.sportRef,event.widgetType,event.geniusId);
    const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType,event.lsportWidgetId);
    const flashbetWidgetUrl = getFlashbetWidgetUrl(event.widgetType);

    return (
        <>
            {widgetContext.widgetMatchId != null && widgetContext.widgetMatchId === event.id &&
                (flashbetWidgetUrl ?
                    <FlashbetWidget url={flashbetWidgetUrl}/>
                    :
                    isBetgeniusWidget ?
                        <BetGeniusWidget url={getBetgeniustWidgetUrl(event.sportRef, event.categoryRef, event.tournamentRef)} />
                    :
                    isStatsCoreWidget ?
                        <StatsCoreWidget />
                    :
                    <div id={"br_widget_checkbet_" + event.ticketRef + '_' + event.id} className={`betradar-widget sr-widget sr-widget-level-0 sr-widgets-lmts sr-size-small sr480 ${isBrWidgetS5 ? 'brWidgetS5' : ''}`} data-sr-lang="it" data-sr-handle="16"></div>
                )
            }
        </>
    );
}
